import {NodeSpec} from 'prosemirror-model';

export type MentionType = 'people' | 'item';

export const mention: NodeSpec = {
    group: 'inline',
    inline: true,
    attrs: {
        guid: {default: null},
        type: {default: 'item'},
        targetId: {},
    },
    parseDOM: [{
        tag: 'span[data-node="mention"]',
        getAttrs: (element: HTMLElement) => {
            return ({
                guid: element.getAttribute('data-guid') as string,
                type: element.getAttribute("data-type"),
                targetId: element.getAttribute("data-target-id"),
            })
        }
    },],
    selectable: true,
    draggable: true,
    toDOM(node) {
        const {guid, type, targetId} = node.attrs;
        let content: any[];
        let notFound = false;
        let href = '#';
        switch (type) {
            case "user": {
                /* @todo implement cached configuration to add UserProvider and rootStore related functions */
                const userInfo = node.type.schema.cached.app.getDsManager().usersDS.users.get(targetId);
                if (userInfo !== null) {
                    content = [['span', {}, userInfo.getFullName(),]];
                } else {
                    content = [['span', {}, targetId,]];
                }
                break
            }
            case "item": {
                const item = node.type.schema.cached.app.getRootStore().view.workspace.items.get(targetId);
                const currentLocale = node.type.schema.cached.app.getRootStore().currentLocale;
                if (item) {
                    let icon = (
                        item.isCluster
                            ? ["span", {class: "material-symbols-rounded"}, 'folder']
                            : ["span", {class: "material-symbols-rounded"}, 'article']
                    )
                    content = [
                        icon,
                        [
                            "span",
                            {},
                            item.getNameWithPlaceholder(currentLocale)
                        ]
                    ];
                    href = node.type.schema.cached.app.getUrlPath(targetId);
                } else {
                    notFound = true;
                    content = [
                        ["span", {class: "material-symbols-rounded"}, 'article'],
                        [
                            "span",
                            {
                                class: "pm-mention__notFound",
                            },
                            node.type.schema.cached.app.intl.get('mention.not_found').d('Not Found')
                        ],
                    ];
                }
                break
            }
            default:
                content = [['span', {}, targetId,]];
        }
        return ["a", {
            target: "_self",
            href: href,
            "class": `pm-mention${notFound ? ' pm-mention--error' : ''}`,
            "data-node": "mention",
            "data-guid": guid,
            "data-type": type,
            "data-target-id": targetId,
        }, ...content]
    },
    dragHandle: true,
}
